/**
 * `dashboard_banner` → `Dashboard banner`, `PREMIUM` → `Premium`. A value in
 * mixed case keeps its case, so a Django admin label such as `Title` stays as
 * it is written.
 */
export const humanizeToken = (value: string): string => {
  const spaced = value.replaceAll('_', ' ').trim()
  const cased = spaced === spaced.toUpperCase() ? spaced.toLowerCase() : spaced

  return cased.charAt(0).toUpperCase() + cased.slice(1)
}
